module.exports = __webpack_public_path__ + "static/media/persona_cara_cuadrada.ae0dd77a.jpg";